module.exports = __webpack_public_path__ + "static/media/retail.2fb6593f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/TeamBox/img/retail.svg
// module id = 81
// module chunks = 0